import { createContext, useContext } from "react";

type ThreadSelection = {
  /**
   * Closing or reopening a thread from an action takes it out of the list, so
   * selection moves to the row below it, the row above it if it was last, or
   * nothing if the list is now empty. No-op unless that thread is the one being
   * read, and unless leaving actually removes it from this list.
   */
  selectNextAfter: (threadId: string) => void;
  /**
   * Keeps a thread listed after it stops belonging to the list, for the one
   * case where the reader didn't aim at the list: replying to a closed thread
   * reopens it. Pulling the row out from under someone mid-conversation is
   * worse than a row that no longer matches the filter.
   *
   * Call before the change that takes the thread out of the list: the row it
   * holds is the one listed at the time of the call.
   */
  holdInList: (threadId: string) => void;
};

const NO_LIST: ThreadSelection = {
  selectNextAfter: () => {},
  holdInList: () => {},
};

export const ThreadSelectionContext = createContext<ThreadSelection>(NO_LIST);

export function useThreadSelection() {
  return useContext(ThreadSelectionContext);
}
